import { MaintenanceWindowGridWebComponent } from './component/MaintenanceWindowGridWebComponent';
import { WEB_COMPONENT_MAINTENANCE_WINDOW_GRID } from '../../webcomponents.constants';

export { MaintenanceWindowGridWebComponent };

window.customElements.define(WEB_COMPONENT_MAINTENANCE_WINDOW_GRID, MaintenanceWindowGridWebComponent);
